export const SET_ACCOUNT_FORM = 'SET_ACCOUNT_FORM'
export const SET_ACCOUNT_FORM_FIELD = 'SET_ACCOUNT_FORM_FIELD'
export const MERGE_ACCOUNT_FORM = 'MERGE_ACCOUNT_FORM'
